export enum PaymentMethod {
    Card = 100,
    Phone = 200,
    BACS = 400
}

export enum PaymentStatus {
    Pending = 100,
    Paid = 200,
    Declined = 300,
    Cancelled = 400
}

export enum SubscriptionServiceType {
    BidManagement = 100,
    Tenders = 200,
    Full = 300
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/subscriptions/subscription.enums.ts